var _rect, _path, _circle, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 32,
    viewBox: "0 0 120 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 8,
    width: 20,
    height: 14,
    rx: 2,
    fill: "#2563eb"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 14C6 12 8 16 10 14C12 12 14 16 16 14C18 12 20 16 20 14",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    fill: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 11,
    r: 1,
    fill: "white"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 28,
    y: 21,
    fontSize: 14,
    fontWeight: 600,
    fill: "#1e293b",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
  }, "PayFlow")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.86255cc4c9870c25f7822b8407853a7d.svg";
export { ForwardRef as ReactComponent };